// @generated by protoc-gen-es v1.9.0 with parameter "target=ts"
// @generated from file no/jotta/openapi/signup/v1/signup.v1.proto (package no.jotta.openapi.signup.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
import { Message, proto3 } from "@bufbuild/protobuf";
import { Language } from "../../language_pb.js";
import { Country } from "../../country_pb.js";
import { Challenges, Credentials } from "../../credentials_pb.js";
/**
 * @generated from message no.jotta.openapi.signup.v1.SignupRequest
 */
export class SignupRequest extends Message {
    /**
     * @generated from field: string customer_group_code = 1;
     */
    customerGroupCode = "";
    /**
     * @generated from field: optional no.jotta.openapi.Language language = 2;
     */
    language;
    /**
     * @generated from field: optional no.jotta.openapi.Country country = 3;
     */
    country;
    /**
     * @generated from field: optional string voucher_code = 4;
     */
    voucherCode;
    /**
     * @generated from field: optional bool wants_newsletter = 5;
     */
    wantsNewsletter;
    /**
     * @generated from field: bytes token = 6;
     */
    token = new Uint8Array(0);
    /**
     * @generated from field: optional string login_token = 7;
     */
    loginToken;
    /**
     * @generated from field: optional string family_invite_id = 8;
     */
    familyInviteId;
    /**
     * @generated from field: bool generate_installation_code = 9;
     */
    generateInstallationCode = false;
    /**
     * @generated from oneof no.jotta.openapi.signup.v1.SignupRequest.request
     */
    request = { case: undefined };
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.signup.v1.SignupRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "customer_group_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "language", kind: "enum", T: proto3.getEnumType(Language), opt: true },
        { no: 3, name: "country", kind: "enum", T: proto3.getEnumType(Country), opt: true },
        { no: 4, name: "voucher_code", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
        { no: 5, name: "wants_newsletter", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
        { no: 6, name: "token", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
        { no: 7, name: "login_token", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
        { no: 8, name: "family_invite_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
        { no: 9, name: "generate_installation_code", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
        { no: 100, name: "federated_signup", kind: "message", T: SignupRequest_FederatedSignup, oneof: "request" },
        { no: 101, name: "form_signup", kind: "message", T: SignupRequest_FormSignup, oneof: "request" },
        { no: 102, name: "phone_number_signup", kind: "message", T: SignupRequest_PhoneNumberSignup, oneof: "request" },
    ]);
    static fromBinary(bytes, options) {
        return new SignupRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SignupRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SignupRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SignupRequest, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.signup.v1.SignupRequest.FederatedSignup
 */
export class SignupRequest_FederatedSignup extends Message {
    /**
     * @generated from field: string token = 1;
     */
    token = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.signup.v1.SignupRequest.FederatedSignup";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new SignupRequest_FederatedSignup().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SignupRequest_FederatedSignup().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SignupRequest_FederatedSignup().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SignupRequest_FederatedSignup, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.signup.v1.SignupRequest.FormSignup
 */
export class SignupRequest_FormSignup extends Message {
    /**
     * @generated from field: string email = 1;
     */
    email = "";
    /**
     * plain text password
     *
     * @generated from field: string password = 2;
     */
    password = "";
    /**
     * @generated from field: string fullname = 3;
     */
    fullname = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.signup.v1.SignupRequest.FormSignup";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "password", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 3, name: "fullname", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new SignupRequest_FormSignup().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SignupRequest_FormSignup().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SignupRequest_FormSignup().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SignupRequest_FormSignup, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.signup.v1.SignupRequest.PhoneNumberSignup
 */
export class SignupRequest_PhoneNumberSignup extends Message {
    /**
     * phone_number must be a fully qualified phone number with an IDD prefix, i.e. '004781549300'.
     *
     * @generated from field: string phone_number = 1;
     */
    phoneNumber = "";
    /**
     * @generated from field: string email = 2;
     */
    email = "";
    /**
     * plain text password
     *
     * @generated from field: string password = 3;
     */
    password = "";
    /**
     * @generated from field: string fullname = 4;
     */
    fullname = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.signup.v1.SignupRequest.PhoneNumberSignup";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "phone_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 3, name: "password", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 4, name: "fullname", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new SignupRequest_PhoneNumberSignup().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SignupRequest_PhoneNumberSignup().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SignupRequest_PhoneNumberSignup().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SignupRequest_PhoneNumberSignup, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.signup.v1.SignupResponse
 */
export class SignupResponse extends Message {
    /**
     * @generated from oneof no.jotta.openapi.signup.v1.SignupResponse.result
     */
    result = { case: undefined };
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.signup.v1.SignupResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "success", kind: "message", T: SignupResponse_Success, oneof: "result" },
        { no: 2, name: "signup_not_supported", kind: "message", T: SignupResponse_SignupNotSupported, oneof: "result" },
        { no: 3, name: "email_in_use", kind: "message", T: SignupResponse_EmailInUse, oneof: "result" },
        { no: 4, name: "redirect", kind: "message", T: SignupResponse_Redirect, oneof: "result" },
    ]);
    static fromBinary(bytes, options) {
        return new SignupResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SignupResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SignupResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SignupResponse, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.signup.v1.SignupResponse.Success
 */
export class SignupResponse_Success extends Message {
    /**
     * @generated from field: string username = 1;
     */
    username = "";
    /**
     * @generated from field: string auto_login_code = 2;
     */
    autoLoginCode = "";
    /**
     * @generated from field: optional string installation_code = 3;
     */
    installationCode;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.signup.v1.SignupResponse.Success";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "username", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "auto_login_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 3, name: "installation_code", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    ]);
    static fromBinary(bytes, options) {
        return new SignupResponse_Success().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SignupResponse_Success().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SignupResponse_Success().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SignupResponse_Success, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.signup.v1.SignupResponse.Redirect
 */
export class SignupResponse_Redirect extends Message {
    /**
     * @generated from field: string url = 1;
     */
    url = "";
    /**
     * @generated from field: optional string installation_code = 2;
     */
    installationCode;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.signup.v1.SignupResponse.Redirect";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "installation_code", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    ]);
    static fromBinary(bytes, options) {
        return new SignupResponse_Redirect().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SignupResponse_Redirect().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SignupResponse_Redirect().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SignupResponse_Redirect, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.signup.v1.SignupResponse.SignupNotSupported
 */
export class SignupResponse_SignupNotSupported extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.signup.v1.SignupResponse.SignupNotSupported";
    static fields = proto3.util.newFieldList(() => []);
    static fromBinary(bytes, options) {
        return new SignupResponse_SignupNotSupported().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SignupResponse_SignupNotSupported().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SignupResponse_SignupNotSupported().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SignupResponse_SignupNotSupported, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.signup.v1.SignupResponse.EmailInUse
 */
export class SignupResponse_EmailInUse extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.signup.v1.SignupResponse.EmailInUse";
    static fields = proto3.util.newFieldList(() => []);
    static fromBinary(bytes, options) {
        return new SignupResponse_EmailInUse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SignupResponse_EmailInUse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SignupResponse_EmailInUse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SignupResponse_EmailInUse, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.signup.v1.BusinessSignupRequest
 */
export class BusinessSignupRequest extends Message {
    /**
     * @generated from field: string business_name = 1;
     */
    businessName = "";
    /**
     * @generated from field: string admin_fullname = 2;
     */
    adminFullname = "";
    /**
     * @generated from field: string admin_email = 3;
     */
    adminEmail = "";
    /**
     * @generated from field: string admin_password = 4;
     */
    adminPassword = "";
    /**
     * @generated from field: string customer_group_code = 5;
     */
    customerGroupCode = "";
    /**
     * @generated from field: optional bool wants_newsletter = 6;
     */
    wantsNewsletter;
    /**
     * @generated from field: optional no.jotta.openapi.Language language = 7;
     */
    language;
    /**
     * @generated from field: optional no.jotta.openapi.Country country = 8;
     */
    country;
    /**
     * @generated from field: optional string voucher_code = 9;
     */
    voucherCode;
    /**
     * @generated from field: bytes token = 10;
     */
    token = new Uint8Array(0);
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.signup.v1.BusinessSignupRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "business_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "admin_fullname", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 3, name: "admin_email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 4, name: "admin_password", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 5, name: "customer_group_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 6, name: "wants_newsletter", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
        { no: 7, name: "language", kind: "enum", T: proto3.getEnumType(Language), opt: true },
        { no: 8, name: "country", kind: "enum", T: proto3.getEnumType(Country), opt: true },
        { no: 9, name: "voucher_code", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
        { no: 10, name: "token", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    ]);
    static fromBinary(bytes, options) {
        return new BusinessSignupRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new BusinessSignupRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new BusinessSignupRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(BusinessSignupRequest, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.signup.v1.BusinessSignupResponse
 */
export class BusinessSignupResponse extends Message {
    /**
     * @generated from oneof no.jotta.openapi.signup.v1.BusinessSignupResponse.result
     */
    result = { case: undefined };
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.signup.v1.BusinessSignupResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "success", kind: "message", T: BusinessSignupResponse_Success, oneof: "result" },
        { no: 2, name: "signup_not_supported", kind: "message", T: BusinessSignupResponse_SignupNotSupported, oneof: "result" },
        { no: 3, name: "email_in_use", kind: "message", T: BusinessSignupResponse_EmailInUse, oneof: "result" },
    ]);
    static fromBinary(bytes, options) {
        return new BusinessSignupResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new BusinessSignupResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new BusinessSignupResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(BusinessSignupResponse, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.signup.v1.BusinessSignupResponse.Success
 */
export class BusinessSignupResponse_Success extends Message {
    /**
     * @generated from field: string username = 1;
     */
    username = "";
    /**
     * @generated from field: string auto_login_code = 2;
     */
    autoLoginCode = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.signup.v1.BusinessSignupResponse.Success";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "username", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "auto_login_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new BusinessSignupResponse_Success().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new BusinessSignupResponse_Success().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new BusinessSignupResponse_Success().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(BusinessSignupResponse_Success, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.signup.v1.BusinessSignupResponse.SignupNotSupported
 */
export class BusinessSignupResponse_SignupNotSupported extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.signup.v1.BusinessSignupResponse.SignupNotSupported";
    static fields = proto3.util.newFieldList(() => []);
    static fromBinary(bytes, options) {
        return new BusinessSignupResponse_SignupNotSupported().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new BusinessSignupResponse_SignupNotSupported().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new BusinessSignupResponse_SignupNotSupported().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(BusinessSignupResponse_SignupNotSupported, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.signup.v1.BusinessSignupResponse.EmailInUse
 */
export class BusinessSignupResponse_EmailInUse extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.signup.v1.BusinessSignupResponse.EmailInUse";
    static fields = proto3.util.newFieldList(() => []);
    static fromBinary(bytes, options) {
        return new BusinessSignupResponse_EmailInUse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new BusinessSignupResponse_EmailInUse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new BusinessSignupResponse_EmailInUse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(BusinessSignupResponse_EmailInUse, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.signup.v1.CheckEmailRequest
 */
export class CheckEmailRequest extends Message {
    /**
     * @generated from field: string email = 1;
     */
    email = "";
    /**
     * @generated from field: string customer_group_code = 2;
     */
    customerGroupCode = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.signup.v1.CheckEmailRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "customer_group_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new CheckEmailRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CheckEmailRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CheckEmailRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CheckEmailRequest, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.signup.v1.CheckEmailResponse
 */
export class CheckEmailResponse extends Message {
    /**
     * @generated from oneof no.jotta.openapi.signup.v1.CheckEmailResponse.result
     */
    result = { case: undefined };
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.signup.v1.CheckEmailResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "email_invalid", kind: "message", T: CheckEmailResponse_EmailInvalid, oneof: "result" },
        { no: 2, name: "email_used", kind: "message", T: CheckEmailResponse_EmailUsed, oneof: "result" },
        { no: 3, name: "email_not_used", kind: "message", T: CheckEmailResponse_EmailNotUsed, oneof: "result" },
    ]);
    static fromBinary(bytes, options) {
        return new CheckEmailResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CheckEmailResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CheckEmailResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CheckEmailResponse, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.signup.v1.CheckEmailResponse.EmailUsed
 */
export class CheckEmailResponse_EmailUsed extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.signup.v1.CheckEmailResponse.EmailUsed";
    static fields = proto3.util.newFieldList(() => []);
    static fromBinary(bytes, options) {
        return new CheckEmailResponse_EmailUsed().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CheckEmailResponse_EmailUsed().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CheckEmailResponse_EmailUsed().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CheckEmailResponse_EmailUsed, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.signup.v1.CheckEmailResponse.EmailNotUsed
 */
export class CheckEmailResponse_EmailNotUsed extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.signup.v1.CheckEmailResponse.EmailNotUsed";
    static fields = proto3.util.newFieldList(() => []);
    static fromBinary(bytes, options) {
        return new CheckEmailResponse_EmailNotUsed().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CheckEmailResponse_EmailNotUsed().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CheckEmailResponse_EmailNotUsed().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CheckEmailResponse_EmailNotUsed, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.signup.v1.CheckEmailResponse.EmailInvalid
 */
export class CheckEmailResponse_EmailInvalid extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.signup.v1.CheckEmailResponse.EmailInvalid";
    static fields = proto3.util.newFieldList(() => []);
    static fromBinary(bytes, options) {
        return new CheckEmailResponse_EmailInvalid().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CheckEmailResponse_EmailInvalid().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CheckEmailResponse_EmailInvalid().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CheckEmailResponse_EmailInvalid, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.signup.v1.CheckPhoneNumberRequest
 */
export class CheckPhoneNumberRequest extends Message {
    /**
     * phone_number must be a fully qualified phone number with an IDD prefix, i.e. '004781549300'.
     *
     * @generated from field: string phone_number = 1;
     */
    phoneNumber = "";
    /**
     * @generated from field: string customer_group_code = 2;
     */
    customerGroupCode = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.signup.v1.CheckPhoneNumberRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "phone_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "customer_group_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new CheckPhoneNumberRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CheckPhoneNumberRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CheckPhoneNumberRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CheckPhoneNumberRequest, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.signup.v1.CheckPhoneNumberResponse
 */
export class CheckPhoneNumberResponse extends Message {
    /**
     * @generated from oneof no.jotta.openapi.signup.v1.CheckPhoneNumberResponse.result
     */
    result = { case: undefined };
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.signup.v1.CheckPhoneNumberResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "phone_number_active", kind: "message", T: CheckPhoneNumberResponse_PhoneNumberActive, oneof: "result" },
        { no: 2, name: "phone_number_in_pre_signup", kind: "message", T: CheckPhoneNumberResponse_PhoneNumberInPreSignup, oneof: "result" },
        { no: 3, name: "phone_number_invalid", kind: "message", T: CheckPhoneNumberResponse_PhoneNumberInvalid, oneof: "result" },
    ]);
    static fromBinary(bytes, options) {
        return new CheckPhoneNumberResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CheckPhoneNumberResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CheckPhoneNumberResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CheckPhoneNumberResponse, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.signup.v1.CheckPhoneNumberResponse.PhoneNumberActive
 */
export class CheckPhoneNumberResponse_PhoneNumberActive extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.signup.v1.CheckPhoneNumberResponse.PhoneNumberActive";
    static fields = proto3.util.newFieldList(() => []);
    static fromBinary(bytes, options) {
        return new CheckPhoneNumberResponse_PhoneNumberActive().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CheckPhoneNumberResponse_PhoneNumberActive().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CheckPhoneNumberResponse_PhoneNumberActive().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CheckPhoneNumberResponse_PhoneNumberActive, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.signup.v1.CheckPhoneNumberResponse.PhoneNumberInPreSignup
 */
export class CheckPhoneNumberResponse_PhoneNumberInPreSignup extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.signup.v1.CheckPhoneNumberResponse.PhoneNumberInPreSignup";
    static fields = proto3.util.newFieldList(() => []);
    static fromBinary(bytes, options) {
        return new CheckPhoneNumberResponse_PhoneNumberInPreSignup().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CheckPhoneNumberResponse_PhoneNumberInPreSignup().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CheckPhoneNumberResponse_PhoneNumberInPreSignup().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CheckPhoneNumberResponse_PhoneNumberInPreSignup, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.signup.v1.CheckPhoneNumberResponse.PhoneNumberInvalid
 */
export class CheckPhoneNumberResponse_PhoneNumberInvalid extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.signup.v1.CheckPhoneNumberResponse.PhoneNumberInvalid";
    static fields = proto3.util.newFieldList(() => []);
    static fromBinary(bytes, options) {
        return new CheckPhoneNumberResponse_PhoneNumberInvalid().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CheckPhoneNumberResponse_PhoneNumberInvalid().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CheckPhoneNumberResponse_PhoneNumberInvalid().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CheckPhoneNumberResponse_PhoneNumberInvalid, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.signup.v1.CheckNameRequest
 */
export class CheckNameRequest extends Message {
    /**
     * @generated from field: string name = 1;
     */
    name = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.signup.v1.CheckNameRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new CheckNameRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CheckNameRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CheckNameRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CheckNameRequest, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.signup.v1.CheckNameResponse
 */
export class CheckNameResponse extends Message {
    /**
     * @generated from oneof no.jotta.openapi.signup.v1.CheckNameResponse.result
     */
    result = { case: undefined };
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.signup.v1.CheckNameResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "valid", kind: "message", T: CheckNameResponse_Valid, oneof: "result" },
        { no: 2, name: "invalid", kind: "message", T: CheckNameResponse_Invalid, oneof: "result" },
    ]);
    static fromBinary(bytes, options) {
        return new CheckNameResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CheckNameResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CheckNameResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CheckNameResponse, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.signup.v1.CheckNameResponse.Valid
 */
export class CheckNameResponse_Valid extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.signup.v1.CheckNameResponse.Valid";
    static fields = proto3.util.newFieldList(() => []);
    static fromBinary(bytes, options) {
        return new CheckNameResponse_Valid().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CheckNameResponse_Valid().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CheckNameResponse_Valid().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CheckNameResponse_Valid, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.signup.v1.CheckNameResponse.Invalid
 */
export class CheckNameResponse_Invalid extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.signup.v1.CheckNameResponse.Invalid";
    static fields = proto3.util.newFieldList(() => []);
    static fromBinary(bytes, options) {
        return new CheckNameResponse_Invalid().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CheckNameResponse_Invalid().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CheckNameResponse_Invalid().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CheckNameResponse_Invalid, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.signup.v1.DescribeVoucherRequest
 */
export class DescribeVoucherRequest extends Message {
    /**
     * @generated from field: string voucher_code = 1;
     */
    voucherCode = "";
    /**
     * @generated from field: string customer_group_code = 2;
     */
    customerGroupCode = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.signup.v1.DescribeVoucherRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "voucher_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "customer_group_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new DescribeVoucherRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DescribeVoucherRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DescribeVoucherRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DescribeVoucherRequest, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.signup.v1.DescribeVoucherResponse
 */
export class DescribeVoucherResponse extends Message {
    /**
     * @generated from oneof no.jotta.openapi.signup.v1.DescribeVoucherResponse.status
     */
    status = { case: undefined };
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.signup.v1.DescribeVoucherResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "valid", kind: "message", T: DescribeVoucherResponse_Valid, oneof: "status" },
        { no: 2, name: "invalid", kind: "message", T: DescribeVoucherResponse_Invalid, oneof: "status" },
        { no: 3, name: "used", kind: "message", T: DescribeVoucherResponse_Used, oneof: "status" },
    ]);
    static fromBinary(bytes, options) {
        return new DescribeVoucherResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DescribeVoucherResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DescribeVoucherResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DescribeVoucherResponse, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.signup.v1.DescribeVoucherResponse.Valid
 */
export class DescribeVoucherResponse_Valid extends Message {
    /**
     * @generated from field: string customer_group_code = 1;
     */
    customerGroupCode = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.signup.v1.DescribeVoucherResponse.Valid";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "customer_group_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new DescribeVoucherResponse_Valid().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DescribeVoucherResponse_Valid().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DescribeVoucherResponse_Valid().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DescribeVoucherResponse_Valid, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.signup.v1.DescribeVoucherResponse.Invalid
 */
export class DescribeVoucherResponse_Invalid extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.signup.v1.DescribeVoucherResponse.Invalid";
    static fields = proto3.util.newFieldList(() => []);
    static fromBinary(bytes, options) {
        return new DescribeVoucherResponse_Invalid().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DescribeVoucherResponse_Invalid().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DescribeVoucherResponse_Invalid().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DescribeVoucherResponse_Invalid, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.signup.v1.DescribeVoucherResponse.Used
 */
export class DescribeVoucherResponse_Used extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.signup.v1.DescribeVoucherResponse.Used";
    static fields = proto3.util.newFieldList(() => []);
    static fromBinary(bytes, options) {
        return new DescribeVoucherResponse_Used().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DescribeVoucherResponse_Used().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DescribeVoucherResponse_Used().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DescribeVoucherResponse_Used, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.signup.v1.VerifyPreSignupRequest
 */
export class VerifyPreSignupRequest extends Message {
    /**
     * @generated from field: string phone_number = 1;
     */
    phoneNumber = "";
    /**
     * @generated from field: string customer_group_code = 2;
     */
    customerGroupCode = "";
    /**
     * @generated from field: no.jotta.openapi.Credentials credentials = 3;
     */
    credentials;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.signup.v1.VerifyPreSignupRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "phone_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "customer_group_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 3, name: "credentials", kind: "message", T: Credentials },
    ]);
    static fromBinary(bytes, options) {
        return new VerifyPreSignupRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new VerifyPreSignupRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new VerifyPreSignupRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(VerifyPreSignupRequest, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.signup.v1.VerifyPreSignupResponse
 */
export class VerifyPreSignupResponse extends Message {
    /**
     * @generated from field: no.jotta.openapi.Challenges challenges = 1;
     */
    challenges;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.signup.v1.VerifyPreSignupResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "challenges", kind: "message", T: Challenges },
    ]);
    static fromBinary(bytes, options) {
        return new VerifyPreSignupResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new VerifyPreSignupResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new VerifyPreSignupResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(VerifyPreSignupResponse, a, b);
    }
}
